<script setup lang="ts">
import { ref } from "vue";

type Props = {
  disabled?: boolean;
};

type Emits = {
  (e: "vote", option: string): void;
};

const { disabled = false } = defineProps<Props>();

const emit = defineEmits<Emits>();
const customOption = ref("");

function submit(): void {
  if (customOption.value.trim() && !disabled) {
    emit("vote", customOption.value.trim());
    customOption.value = "";
  }
}
</script>

<template>
  <div class="mt-1 flex items-center gap-2">
    <input
      v-model="customOption"
      type="text"
      class="flex-1 appearance-none rounded-sm border-2 border-kekkle-dark bg-white px-3 py-2 text-sm font-medium text-kekkle-dark shadow-purple-hard-sm outline-hidden focus:ring-3 focus:ring-kekkle-purple dark:bg-kekkle-dark-light dark:text-slate-200"
      :placeholder="
        $t('pages.dilemmas.other_placeholder', 'Or write your own...')
      "
      :disabled="disabled"
      @keyup.enter="submit"
    />
    <button
      :disabled="!customOption.trim() || disabled"
      type="button"
      class="rounded-sm border-2 border-kekkle-dark bg-kekkle-yellow px-4 py-2 text-xs font-bold text-kekkle-dark shadow-yellow-hard-sm transition-all active:translate-y-0.5 active:shadow-none disabled:opacity-50"
      @click="submit"
    >
      {{ $t("global.inputs.labels.vote", "Vote") }}
    </button>
  </div>
</template>
